var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function WithdrawVoteOutline(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M38.1 38.45L33.85 42.7L31.75 40.6L36 36.35L31.75 32.1L33.85 30L38.1 34.25L42.35 30L44.45 32.1L40.2 36.35L44.45 40.6L42.35 42.7L38.1 38.45ZM11.25 44C9.78333 44 8.54167 43.4917 7.525 42.475C6.50833 41.4583 6 40.2167 6 38.75V32H12V4H42V26.3C41.5333 26.1333 41.05 26 40.55 25.9C40.05 25.8 39.5333 25.7167 39 25.65V7H15V32H28.3C28.1 32.4667 27.9333 32.95 27.8 33.45C27.6667 33.95 27.5667 34.4667 27.5 35H9V38.75C9 39.3833 9.21667 39.9167 9.65 40.35C10.0833 40.7833 10.6 41 11.2 41H28.45C28.7167 41.5667 29.0333 42.1 29.4 42.6C29.7667 43.1 30.1667 43.5667 30.6 44H11.25ZM18 16V13H36V16H18ZM18 22V19H36V22H18ZM28.45 41H9H27.5H27.4H28.45Z", fill: color }) })));
}
